import React, { Component } from 'react';
import { Button, Avatar } from 'components';
import { withStyles, createStyleSheet } from 'material-ui/styles';

import { CircularProgress } from 'material-ui/Progress';
import green from 'material-ui/colors/green';
import AddAPhotoIcon from 'material-ui-icons/AddAPhoto';

import classNames from 'classnames';

const styleSheet = createStyleSheet('FileInput', theme => {
  return {
    container: {
      position: 'relative',
      display: 'flex',
      justifyContent: 'center',
      marginBottom: 24,
    },
    wrapper: {
      display: 'inline-block',
      position: 'relative',
    },
    avatar: {
      width: 100,
      height: 100,
    },
    AddAPhotoIcon: {
      width: 48,
      height: 48,
    },
    fab: {
      width: 100,
      height: 100,
    },
    successButton: {
      backgroundColor: green[500],
      '&:hover': {
        backgroundColor: green[700],
      },
    },
    progress: {
      color: green[500],
      position: 'absolute',
      top: -2,
      left: -2,
    },
  };
});

class FileInput extends Component {
  state = {
    loading: false,
    success: false,
    imageUrl: null,
    imageId: null,
  };

  handleFileUpload = e => {
    this.fileInputRef.click();
  };

  uploadImage = async () => {
    this.setState({ loading: true });
    const api = process.env.REACT_APP_GRAPH_COOL_FILE;
    const data = new FormData();
    const file = this.fileInputRef.files[0];

    data.append('data', file);

    try {
      const response = await fetch(api, {
        method: 'POST',
        body: data,
        mode: 'cors',
        headers: {
          'Access-Control-Allow-Origin': '*',
        },
      });
      const imageData = await response.json();

      this.setState(
        {
          imageId: imageData.id,
          imageUrl: imageData.url,
          success: true,
          loading: false,
        },
        () => this.props.onSuccess(imageData)
      );
    } catch (error) {
      console.error('error', error);
      this.props.onFailure(error);
    }
  };

  render() {
    const { classes } = this.props;
    const { loading, success } = this.state;

    return (
      <div className={classes.container}>
        <div className={classes.wrapper}>
          <input
            type="file"
            accept="image/*"
            style={{ display: 'none' }}
            ref={fileInputRef => (this.fileInputRef = fileInputRef)}
            onChange={this.uploadImage}
            multiple={false}
          />
          <Button
            fab
            color="primary"
            className={classNames(classes.fab, {
              [classes.successButton]: success,
            })}
            onClick={this.handleFileUpload}
          >
            {success
              ? <Avatar className={classes.avatar} src={this.state.imageUrl} />
              : <AddAPhotoIcon className={classes.AddAPhotoIcon} />}
          </Button>
          {loading &&
            <CircularProgress size={105} className={classes.progress} />}
        </div>
      </div>
    );
  }
}

export default withStyles(styleSheet)(FileInput);



// WEBPACK FOOTER //
// ./src/common/components/FileInput.js